<ng-container *ngIf="defaultLink && (!options || options.length === 0); else noLink">
  <a [customRouterLink]="defaultLink" class="drop-down">
    <div *ngIf="icon" class="icon">
      <img alt="{{ icon.alt }}" class="icon" src="{{ icon.icon }}" title="{{ icon.title }}"/>
    </div>
    <div class="container">
      <div class="select-box">
      <span class="title">
        {{ title }}
      </span>
      </div>
    </div>
  </a>
</ng-container>
<ng-template #noLink>
  <div #dropDown (blur)="hideDropDown()"
       (click)="showOnClick()" class="drop-down {{ showDropDownOnClick ? 'show-on-click' : 'show-on-hover' }}" tabindex="1">
    <div *ngIf="icon" class="icon">
      <img alt="{{ icon.alt }}" class="icon" src="{{ icon.icon }}" title="{{ icon.title }}"/>
    </div>
    <div class="container">
      <div class="select-box">
      <span class="title">
        <b *ngIf="showSelectedOption && selectedOptionPosition === 'before'">{{ selectedOption?.value }}</b> {{ title }}
        <b *ngIf="showSelectedOption && selectedOptionPosition === 'behind'">{{ selectedOption?.value }}</b>
      </span>
        <img alt="drop_down_arrow_down_icon" class="icon" src="./assets/ui/shared/icons/drop_down_arrow_down_icon.svg"
             title="drop_down_arrow_down_icon"/>
      </div>
      <div class="body">
        <div #dropDownOption [ngStyle]="{top: topPosition, right: leftPosition} " [style.width.px]="width"
             class="select-box-options">
          <kion-drop-down-list-item
            (selected)="optionSelected($event)"
            *ngFor="let option of options"
            [option]="option"
          ></kion-drop-down-list-item>
        </div>
      </div>
    </div>
  </div>
</ng-template>
